module.exports = __webpack_public_path__ + "img/carshina22_28.ffa73e2d.jpg";